import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {GlobalService} from '../../../services/global.service';
import {AdminServices} from '../../../services/admin.services';

@Component({
    selector: 'app-upload-person-blocked',
    templateUrl: './upload-person-blocked.component.html',
    styleUrls: ['./upload-person-blocked.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UploadPersonBlockedComponent implements OnInit {
  permissionAccess:boolean = false;
  fileToUpload: any;
  constructor(
    public globalServices: GlobalService,
    public adminServices: AdminServices,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.verifyPermissionAccess();
  }

  async getInfoLPB(event) {
    if (event.target.files.length > 0) {

      this.fileToUpload = event.target.files[0];

      if(this.fileToUpload.type === 'text/csv'){

        this.fileToUpload = await this.readFile(this.fileToUpload);
        
      }else{
        this.showMeesage("El archivo seleccionado no es CSV");
      }
    }else{
      this.showMeesage("No se pudo leer el archivo");
    }
  }

  onSentDataPerson(){
    if(this.fileToUpload){
      let data = { listPerson: this.fileToUpload }
      this.adminServices.registerPersonBlocked(data).subscribe((res) => {
        if(!res.error){
          this.globalServices.prepareAlert({title: "Exito", message: res.message, label: "success"})
              .subscribe((result)=>{
               });
        }else{
          this.globalServices.prepareAlert({title: "Error", message: res.message, label: "error"})
              .subscribe((result)=>{ 
              });
        }
        setTimeout(() => {
          window.location.reload();
        },4000)
      });
    }else{
      this.showMeesage("Es necesario que seleccione el archivo CSV");
    }
  }

  readFile(file){
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function (e) {
          resolve(e.target.result.toString().split("\r\n"));
        } 
    });
  }

  showMeesage(message) {
    this._snackBar.open(message, '', {
      duration: 4000,
      verticalPosition: 'top',
      horizontalPosition: "center"
    });
  }

  verifyPermissionAccess(){
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if(modulesPermission.includes('upload_person_blocked_mod')){
      this.permissionAccess = true;
    }
  }
}
